import { Injectable } from '@angular/core';
import { Account, AuthTokens } from '../models';

const ACCESS_TOKEN_KEY = 'mle_cms_access_token';
const REFRESH_TOKEN_KEY = 'mle_cms_refresh_token';
const USER_KEY = 'mle_cms_current_user';

/**
 * Thin wrapper around `localStorage` so the storage mechanism (and its key names) is swappable
 * in one place. The API has no cookies/sessions — this is the only place tokens are persisted.
 */
@Injectable({ providedIn: 'root' })
export class TokenStorageService {
  setTokens(tokens: AuthTokens): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, tokens.accessToken);
    localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refreshToken);
  }

  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setUser(user: Account): void {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }

  getUser(): Account | null {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw) {
      return null;
    }
    try {
      return JSON.parse(raw) as Account;
    } catch {
      return null;
    }
  }

  clear(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  }
}
